<template>
  <div class="user-avator-dropdown">
    <Dropdown @on-click="handleClick">
      <!-- <Badge :dot="!!messageUnreadCount"> -->
      <!-- <Avatar :src="userAvator" >{{userName}}</Avatar> -->
      <span>{{userName}}</span>
      <!-- </Badge> -->

      <Icon :size="18"
            type="md-arrow-dropdown"></Icon>
      <DropdownMenu slot="list">
        <!-- <DropdownItem name="message">
          消息中心<Badge style="margin-left: 10px"
                 :count="messageUnreadCount"></Badge>
        </DropdownItem> -->
        <DropdownItem name="editMyinfo">修改个人信息</DropdownItem>
        <DropdownItem name="logout">退出登录</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
</template>

<script>
import './user.less';
import { mapActions } from 'vuex';
export default {
  name: 'User',
  props: {
    userAvator: {
      type: String,
      default: ''
    },

    messageUnreadCount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    userName () {
      return this.$store.state.user.userName;
    },
    token () {
      return this.$store.state.user.token;
    }
  },
  methods: {
    ...mapActions(['handleLogOut']),
    logout () {
      this.handleLogOut().then(() => {
        this.$router.push({
          name: 'login'
        });
      });
    },

    message () {
      this.$router.push({
        name: 'message_page'
      });
    },
    editMyinfo () {
      // alert('editMyinfo');
      this.$router.push({
        name: 'useredit',
        params: {
          token: this.token
        }
      });
    },
    handleClick (name) {
      switch (name) {
        case 'logout':
          this.logout();
          break;
        case 'message':
          this.message();
          break;
        case 'editMyinfo':
          this.editMyinfo();
          break;
      }
    }
  }
};
</script>
